@if (columnModel.isEditable && !!control) {
    <arc-general-data-select
        [generalDataType]="castedCellModel.generalDataType"
        [formControl]="control | formControl"
        class="h-full w-full"
        (optionSelected)="onOptionSelected($event)" />
} @else {
    <arc-general-data-select [generalDataType]="castedCellModel.generalDataType" [formControl]="readonlyControl" class="h-full w-full" />
}
